// Shared component styles. Preserve selector order, style values, and caller overrides.
export const PURPLE = "#9C4FFF";
export const DISABLED = "#98A2B3";
export const FILLED_BG = "#9C4FFF";
export const DIVIDER_COLOR = "#D0D5DD";
export const DIVIDER_HEIGHT = 20;
export const actionIconStyles = {
  icon: ({
    size,
    color
  }) => ({
    width: size,
    height: size,
    display: "block",
    color,
    flex: "0 0 auto"
  }),
  websiteIcon: () => ({
    display: "block"
  }),
  linkedInIcon: () => ({
    display: "block"
  }),
  socialIcon: () => ({
    display: "block"
  }),
  group: ({
    resolvedGap
  }) => ({
    flexWrap: "wrap",
    maxWidth: "100%",
    minWidth: 0,
    rowGap: resolvedGap
  }),
  action: ({
    isFilled,
    pillWidth,
    pillHeight,
    iconColor,
    disabled
  }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: isFilled ? pillWidth : "auto",
    height: isFilled ? pillHeight : "auto",
    minWidth: isFilled ? pillWidth : undefined,
    borderRadius: isFilled ? "999px" : undefined,
    backgroundColor: isFilled ? FILLED_BG : "transparent",
    textDecoration: "none",
    lineHeight: 1,
    color: iconColor,
    opacity: disabled ? 0.42 : 1,
    transition: "opacity 0.15s ease",
    cursor: disabled ? "default" : "pointer",
    "&:hover": disabled ? undefined : {
      opacity: 0.92,
      backgroundColor: isFilled ? FILLED_BG : "transparent"
    }
  }),
  singleGroup: ({
    resolvedGap
  }) => ({
    flexWrap: "wrap",
    rowGap: resolvedGap,
    minWidth: 0
  }),
  groupedActions: ({
    resolvedGap
  }) => ({
    flexWrap: "wrap",
    maxWidth: "100%",
    minWidth: 0,
    rowGap: resolvedGap
  }),
  divider: ({
    resolvedGap
  }) => ({
    width: "1px",
    height: DIVIDER_HEIGHT,
    backgroundColor: DIVIDER_COLOR,
    mx: resolvedGap,
    flex: "0 0 auto"
  })
};
